export class ConfirmModelConfig{
    show : boolean = false;
    showSelectedFilters: boolean = false;
    isLoading: boolean = false;
    isLoadingSinceMoreThan8Secs: boolean = false;
    showExportPopup:boolean = false;
    selectedRecordsCount:number=0;
    disableExport :boolean = false;
}